import { render, staticRenderFns } from "./planDialog.vue?vue&type=template&id=6bfb714a&scoped=true"
import script from "./planDialog.vue?vue&type=script&lang=js"
export * from "./planDialog.vue?vue&type=script&lang=js"
import style0 from "./planDialog.vue?vue&type=style&index=0&id=6bfb714a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb714a",
  null
  
)

export default component.exports